// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { background } from '../../tokens/themeColors/background';
import { gradient, toCssGradient } from '../../tokens/themeColors/gradient';
import { inverseBackground, inverseIcon } from '../../tokens/themeColors/inverse';
import { text } from '../../tokens/themeColors/text';
// Figma: Default/Default/Hover/Active alias to Button/Primary tokens (the same
// tokens Button.tsx's `primary` uses). Action/Default/Hover/Active alias to
// Background Colors/Status Colors/Info - Bold (and its Hover/Active variants);
// Icon and Text both alias to Text Colors/White. Disabled shares Button/Primary/
// Disabled tokens (bg.state.disabled2 / tx.disabled2) across all three styles.
export var fabColors = function(mode) {
    var bg = background(mode);
    var tx = text(mode);
    var gr = gradient(mode);
    // Default (Button/Primary) uses opposite-mode tokens, same formula as Button.tsx.
    var inverseBg = inverseBackground(mode);
    var inverseIc = inverseIcon(mode);
    return {
        default: {
            default: {
                background: inverseBg.level50,
                icon: inverseIc.heaviest,
                text: tx.action
            },
            hover: {
                background: inverseBg.level300
            },
            active: {
                background: inverseBg.state.selected3,
                icon: inverseIc.heaviest,
                text: tx.action
            }
        },
        action: {
            default: {
                background: bg.status.infoBold,
                icon: tx.white,
                text: tx.white
            },
            hover: {
                background: bg.status.hover.infoBold
            },
            active: {
                background: bg.status.active.infoBold
            }
        },
        special: {
            default: {
                background: toCssGradient(gr.accentLinear.default),
                icon: tx.white,
                text: tx.white
            },
            hover: {
                background: toCssGradient(gr.accentLinear.hover)
            },
            active: {
                background: toCssGradient(gr.accentLinear.active)
            }
        },
        disabled: {
            background: bg.state.disabled2,
            icon: tx.disabled2,
            text: tx.disabled2
        }
    };
};

//# sourceMappingURL=fabColors.js.map